<template>
  <div class="box">
    <div class="txt">
      <div class="title">文旦安心保《软件服务协议》</div>
      <div class="paragraph">
        您即将为种植的文旦提交保险相关信息（如种植面积、土地情况等），以便我们为您办理「文旦安心保」投保/核保/理赔服务。以下条款需确认后提交，确保您的权益清晰、信息使用透明。
      </div>
      <div class="subtitle">一、我们会收集哪些与文旦种植相关的信息？</div>
      <div class="paragraph">
        为准确评估风险、快速处理理赔，我们需要收集以下必要信息：
      </div>
      <div class="paragraph">
        1.基础种植信息
      </div>
      <div class="paragraph">
        种植人信息：姓名、身份证号（用于确认投保主体）、联系电话（接收灾害预警/理赔通知）；
      </div>
      <div class="paragraph">
        种植地块信息：
      </div>
      <div class="paragraph">
        面积：文旦种植总面积（亩/公顷，需与土地承包合同一致）；
      </div>
      <div class="paragraph">
        理赔信息：
      </div>
      <div class="paragraph">
        理赔银行：需为支持农业保险理赔的一类借记卡；
      </div>
      <div class="paragraph">理赔银行卡号：用于接收保险赔偿金（需与种植人身份证姓名一致，避免因姓名不符导致打款失败）；</div>
      <div class="subtitle">二、我们会如何使用这些信息？</div>
      <div class="paragraph">
        我们承诺仅将信息用于「文旦安心保」的投保、核保、理赔及风险服务，具体用途如下：
      </div>
      <div class="paragraph">
        1.核保阶段：验证信息真实性
      </div>
      <div class="paragraph">
        确认种植人身份：通过身份证号核查是否为实际种植者；
      </div>
      <div class="paragraph">
        核对地块信息：比对土地承包合同，确认种植面积、地址与实际一致；
      </div>
      <div class="paragraph">
        验证银行卡有效性：检查银行卡是否为一类借记卡、姓名是否与种植人一致。
      </div>
      <div class="paragraph">
        2.理赔阶段：赔付对应信息
      </div>
      <div class="paragraph">
        确定理赔账户：事故发生后，系统自动提取您提交的银行卡号，将赔偿金直接打入该账户。
      </div>
      <div class="paragraph">
        3.风险服务阶段：降低种植损失
      </div>
      <div class="paragraph">
        发送灾害预警：根据气象预报，通过您预留的电话通知“台风即将登陆”；
      </div>
      <div class="paragraph">
        未经您的单独同意，我们不会将信息用于其他服务。
      </div>
      <div class="subtitle">三、您的信息会被如何存储和保护？</div>
      <div class="paragraph">
        1.存储期限
      </div>
      <div class="paragraph">
        业务存续期：自保险合同生效起，至合同终止/履行完毕止（如文旦采摘期结束后1年）；
      </div>
      <div class="paragraph">
        法定留存期：合同终止后，按《农业保险条例》留存；
      </div>
      <div class="paragraph">
        过期处理：到期后30个工作日内，系统自动加密归档至“文旦种植档案库”，仅保留基础信息（姓名、地块），其他敏感信息（如土地承包证扫描件）彻底删除。
      </div>
      <div class="paragraph">
        2.技术防护措施
      </div>
      <div class="paragraph">
        加密传输：信息提交时采用HTTPS协议（SSL 1.3加密），防止网络截获；
      </div>
      <div class="paragraph">
        存储加密：所有敏感信息（身份证号、银行卡号）采用AES算法加密存储；
      </div>
      <div class="paragraph">
        操作日志：每次信息查看/修改均记录操作人、时间，日志保存半年备查。
      </div>
      <div class="subtitle">四、特别注意事项</div>
      <div class="paragraph">
        信息真实很重要：
      </div>
      <div class="paragraph">
        若提交虚假信息（如虚报种植面积、银行卡号与姓名不符），保险公司有权拒赔，且可能影响您未来参保资格；
      </div>
      <div class="paragraph">
        银行卡需为本人名下借记卡，不可使用他人银行卡（否则理赔款无法到账，还可能涉及诈骗风险）。
      </div>
      <div class="paragraph">
        银行卡安全需注意：
      </div>
      <div class="paragraph">
        请妥善保管理赔银行卡，避免丢失或泄露密码；
      </div>
      <div class="paragraph">
        若银行卡丢失，立即拨打银行客服挂失；
      </div>
      <div class="paragraph">
        切勿将银行卡信息告知他人（包括自称“保险公司工作人员”的陌生电话），所有理赔款到账前无需提供银行卡密码或验证码。
      </div>
      <div class="paragraph">
        及时更新信息：
      </div>
      <div class="paragraph">
        若更换手机号、地块转租，需及时通知我们更新，否则灾害预警/理赔通知可能无法接收；
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    padding: 30px
    .txt{
        text-align: left
        font-size: 24px
        .subtitle{
          font-weight: bold
        }
        .title{
          font-size: 32px
          text-align: center
          font-weight: bold
          margin-bottom: 20px
        }
        .paragraph{
          text-indent: 2em
        }
      }
  }
}
</style>
